import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'confirmation.modal.title',
    defaultMessage: 'Confirmation',
    description: 'Confirmation modal title',
  },
  confirmation: {
    id: 'confirmation.modal.confirmation.text',
    defaultMessage: 'Are you sure you want to unselect and update?',
    description: 'Confirmation modal confirmation body text',
  },
  confirm: {
    id: 'confirmation.modal.confirm.text',
    defaultMessage: 'Confirm',
    description: 'Confirmation modal confirm button text',
  },
  cancel: {
    id: 'confirmation.modal.cancel.text',
    defaultMessage: 'Cancel',
    description: 'Confirmation modal cancel button text',
  },
});

export default messages;
